module.exports = __webpack_public_path__ + "img/Arrow_Left.554b47f1.svg";